// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectGraph_container__3jJMe","toggle":"SelectGraph_toggle__2irvY","graph":"SelectGraph_graph__L2Xb4","table":"SelectGraph_table__pSBx-"};